import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: 56px 56px 48px;
  background: #0a0a0a;
  border: 1.5px solid rgba(247, 213, 24, 0.5);
  border-radius: 24px;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  word-break: break-word;

  ${MediaQueries.mobileTablet`
    padding: 40px 24px 32px;
    gap: 20px;
  `}

  ${MediaQueries.mobile`
    padding: 32px 20px 28px;
    gap: 20px;
    border-radius: 20px;
  `}
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #f7d518;
  border-radius: 999px;
  color: #0a0a0a;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  white-space: nowrap;
`;

export const BadgeIcon = styled.span`
  font-size: 13px;
  line-height: 1;
`;

export const BadgeText = styled.span`
  font-size: 14px;
  letter-spacing: 1.4px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 44px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;

  ${MediaQueries.mobileTablet`
    font-size: 34px;
  `}

  ${MediaQueries.mobile`
    font-size: 26px;
  `}
`;

export const Subtitle = styled.p`
  margin: 0;
  max-width: 634px;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 15px;
  `}
`;

export const CounterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px 48px;
  background: #1c1c20;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  overflow: hidden;

  ${MediaQueries.mobile`
    padding: 20px 16px;
    gap: 12px;
    width: 100%;
  `}
`;

export const CounterLabel = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 13px;
  letter-spacing: 2.2px;
  color: #f7d518;
  white-space: nowrap;

  ${MediaQueries.mobile`
    font-size: 11px;
    letter-spacing: 1.8px;
  `}
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;

  ${MediaQueries.mobile`
    gap: 6px;
  `}
`;

export const CounterCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 24px 14px;
  background: rgba(247, 213, 24, 0.12);
  border-radius: 14px;

  ${MediaQueries.mobileTablet`
    padding: 14px 16px 12px;
    border-radius: 12px;
  `}

  ${MediaQueries.mobile`
    padding: 10px 8px 8px;
    border-radius: 10px;
    min-width: 52px;
  `}
`;

export const CounterValue = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 72px;
  line-height: 1;
  color: #ffffff;

  ${MediaQueries.mobileTablet`
    font-size: 52px;
  `}

  ${MediaQueries.mobile`
    font-size: 32px;
  `}
`;

export const CounterUnit = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 1.6px;
  color: #f7d518;

  ${MediaQueries.mobile`
    font-size: 9px;
    letter-spacing: 1.2px;
  `}
`;

export const CounterSeparator = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 56px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.4);

  ${MediaQueries.mobileTablet`
    font-size: 40px;
  `}

  ${MediaQueries.mobile`
    font-size: 22px;
  `}
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  background: transparent;
  border: 1.5px solid #f7d518;
  border-radius: 999px;
  color: #f7d518;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 1px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: rgba(247, 213, 24, 0.12);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ArrowIcon = styled.span`
  font-weight: 900;
  line-height: 1;
`;
